module.exports = __webpack_public_path__ + "img/pdf1.d2a97708.svg";